/**
*
*   Content Block
*       - A left/right content block + image or video
*
**/
'use client';

import Config from '@/config';
import Image from '@/components/image';
import Button from '@/components/button';
import { header } from '@/components/header/wrapper';
import { useLocale, useTranslations } from 'next-intl';
import { useRef } from 'react';

//Build the Element
export default function Included({ product, ...props }){

    const ref = useRef();
    const locale = useLocale();
    const t = useTranslations();

    //Return
    return (
        <section id="whats-included" className="container" ref={ ref }>
            <header>
                <h2>{ t.rich('Pages.Product.Included.title') }</h2>
            </header>
            <ul class="collection">{
                product.whatsIncluded.map( ( item , i ) => (
                    <li key={i}>
                        <div className="image">
                            <Image src={ item.image[0].src } alt="" width="110" height="110" />
                        </div>
                        <h3>{ item.name[ locale ] }</h3>
                        { item?.inci && (
                            <p className="inci">{ item.inci }</p>
                        )}
                        <div className="profile">
                            <span className="scent">{ item.profile?.[ locale ] }</span>
                            <span className="benefits">{ item.benefits?.[ locale ] }</span>
                        </div>
                        <div className="details">
                            <span className="type">{ item.type[ locale ] }</span>
                        </div>
                        <p>{ item.description[ locale ] }</p>
                    </li>
                ))
            }</ul>
        </section>
    );

}